import { useMemo } from "react";
import { useLocale } from "react-aria-components";
import {
    toLongDate,
    toLongDateWithTime,
    toLongDateWithTimeAndZone,
    toLongDateWithYear,
    toLongUTCDateWithYear,
    toNumericDate,
    toShortDate,
    toShortDateWithTime,
    toShortDateWithYear,
    toShortUTCDate
} from "./formatDate.ts";
import { formatTimestampedFileName } from "./formatTimestampedFileName.ts";

type DateInput = Date | string | number;

export function useDateFormatters() {
    const { locale } = useLocale();

    return useMemo(
        () => ({
            toNumericDate: (date: DateInput) => toNumericDate(date, locale),
            toLongDateWithYear: (date: DateInput) => toLongDateWithYear(date, locale),
            toLongUTCDateWithYear: (date: DateInput) => toLongUTCDateWithYear(date, locale),
            toLongDate: (date: DateInput) => toLongDate(date, locale),
            toLongDateWithTime: (date: DateInput) => toLongDateWithTime(date, locale),
            toLongDateWithTimeAndZone: (date: DateInput) => toLongDateWithTimeAndZone(date, locale),
            toShortDate: (date: DateInput) => toShortDate(date, locale),
            toShortDateWithYear: (date: DateInput) => toShortDateWithYear(date, locale),
            toShortUTCDate: (date: DateInput) => toShortUTCDate(date, locale),
            toShortDateWithTime: (date: DateInput) => toShortDateWithTime(date, locale),
            formatTimestampedFileName: (name: string) => formatTimestampedFileName(name, locale)
        }),
        [locale]
    );
}

export type DateFormatters = ReturnType<typeof useDateFormatters>;
